import SiblingDiscountAlert, {
  SIBLING_DISCOUNT_ALERT_MODAL,
} from './SiblingDiscountAlert';

export { SIBLING_DISCOUNT_ALERT_MODAL };

export default SiblingDiscountAlert;
